import { useState, useEffect, useCallback } from 'react';

const API = '/api/felipe';

function authHeaders() {
  return { Authorization: `Bearer ${localStorage.getItem('token')}` };
}

// ── MOCK DATA (solo mientras no haya datos reales) ────────────
const MOCK_INTERNALS = [
  { id: 'db',         label: 'Base de datos',      category: 'PostgreSQL',        icon: '🗄️', status: 'ok',   value: 'Conectado',   detail: 'Query: 38ms',         metrics: [{ label: 'Conexiones', value: '8/20', status: 'ok' }, { label: 'Query basis', value: '38ms', status: 'ok' }, { label: 'Query lenta', value: 'OK', status: 'ok' }, { label: 'Tamaño BD', value: '1.2GB', status: 'ok' }], history: [100,100,100,100,98,100,100,100,100,100,100,100] },
  { id: 'api',        label: 'API Express',         category: 'todos los endpoints',icon: '⚡', status: 'ok',   value: '200 OK',      detail: '142ms',               metrics: [{ label: 'Latencia', value: '142ms', status: 'ok' }, { label: 'Uptime', value: '14d 3h', status: 'ok' }, { label: 'Estado HTTP', value: '200', status: 'ok' }], history: [100,100,100,98,100,100,100,99,100,100,100,100] },
  { id: 'login',      label: 'Login & Auth',        category: 'JWT / bcrypt',      icon: '🔐', status: 'ok',   value: '5 usuarios',  detail: 'bcrypt OK',           metrics: [{ label: 'Agentes KC', value: '5', status: 'ok' }, { label: 'JWT activas', value: '3', status: 'ok' }, { label: 'bcrypt', value: 'OK', status: 'ok' }, { label: 'Bloqueados', value: '0', status: 'ok' }], history: [100,100,100,100,100,100,100,100,100,100,100,100] },
  { id: 'smtp',       label: 'SMTP Usuarios',       category: 'Email usuarios',    icon: '📧', status: 'warn', value: '3/4 OK',      detail: 'Josefa: timeout',     metrics: [{ label: 'Rita', value: 'OK', status: 'ok' }, { label: 'Josefa', value: 'Fallo', status: 'error' }, { label: 'Antonia', value: 'OK', status: 'ok' }, { label: 'Sabrina', value: 'OK', status: 'ok' }], history: [100,100,100,100,100,98,95,97,100,100,98,90] },
  { id: 'photos',     label: 'Subida de fotos',     category: 'Multer + R2',       icon: '📸', status: 'ok',   value: '23 hoy',      detail: 'R2 Storage OK',       metrics: [{ label: 'Subidas OK', value: '23', status: 'ok' }, { label: 'Pendientes', value: '0', status: 'ok' }, { label: 'Límite multer', value: '5MB', status: 'ok' }, { label: 'R2 Storage', value: 'OK', status: 'ok' }], history: [100,100,100,100,100,100,100,100,100,100,100,100] },
  { id: 'pwa',        label: 'PWA Móvil',           category: 'App mobile',        icon: '📱', status: 'ok',   value: 'OK',          detail: 'login + navegación OK',metrics: [{ label: 'Login', value: 'OK', status: 'ok' }, { label: 'Manifest', value: 'Válido', status: 'ok' }, { label: 'Latencia', value: '320ms', status: 'ok' }], history: [100,100,100,98,100,100,100,100,100,100,100,100] },
  { id: 'jwt',        label: 'Sesiones JWT',        category: 'Autenticación',     icon: '🎫', status: 'ok',   value: '3 activas',   detail: 'dentro del tiempo de vida', metrics: [{ label: 'Activas', value: '3', status: 'ok' }, { label: 'Más antigua', value: 'hace 2h', status: 'ok' }, { label: 'Expiradas', value: 'Purgadas', status: 'ok' }, { label: 'Bloqueados', value: '0', status: 'ok' }], history: [100,100,100,100,100,100,100,100,100,100,100,100] },
];

const MOCK_EXTERNALS = [
  { id: 'telnyx',       label: 'Telnyx',        category: 'Telefonía / SMS',  icon: '📞', status: 'ok',      value: '€84.20',      detail: 'Saldo OK',       metrics: [{ label: 'Saldo', value: '€84.20', status: 'ok' }, { label: 'Tipo', value: 'SIP / SMS', status: 'ok' }], history: [100,100,100,100,100,100,100,100,100,100,100,100] },
  { id: 'elevenlabs',   label: 'ElevenLabs',    category: 'Síntesis de voz',  icon: '🔊', status: 'ok',      value: '8.4k chars',  detail: '72% usado',      metrics: [{ label: 'Usado', value: '360k chars', status: 'ok' }, { label: 'Límite', value: '500k chars', status: 'ok' }, { label: '% uso', value: '72%', status: 'ok' }], history: [100,100,100,100,98,100,100,100,100,100,100,100] },
  { id: 'anthropic',    label: 'Anthropic',     category: 'LLM API',          icon: '🧠', status: 'ok',      value: 'Online',      detail: 'Claude Sonnet',  metrics: [{ label: 'Modelo', value: 'claude-sonnet', status: 'ok' }, { label: 'Estado', value: 'Online', status: 'ok' }], history: [100,100,100,100,100,100,100,100,100,100,100,100] },
  { id: 'autoenhanced', label: 'Auto Enhanced', category: 'Mejora imagen',    icon: '✨', status: 'ok',      value: '—',          detail: 'Cargando cuenta…', metrics: [{ label: 'Saldo', value: '—', status: 'ok', periodo: true }, { label: 'Hoy', value: '—', status: 'ok', periodo: true }, { label: 'Semana', value: '—', status: 'ok', periodo: true }, { label: 'Mes', value: '—', status: 'ok', periodo: true }, { label: 'Año', value: '—', status: 'ok', periodo: true }], history: [100,100,100,100,100,100,100,100,100,100,100,100] },
  { id: 'tavus',        label: 'Tavus',         category: 'Vídeo / Lip-sync', icon: '🎬', status: 'ok',      value: '€120.00',     detail: 'API operativa',  metrics: [{ label: 'Réplicas', value: '2', status: 'ok' }, { label: 'Estado', value: 'Online', status: 'ok' }], history: [100,100,100,100,100,100,100,100,100,100,100,100] },
  { id: 'railway',      label: 'Railway',       category: 'Backend infra',    icon: '🚂', status: 'ok',      value: '€18.40/mes',  detail: 'Pro Plan',       metrics: [{ label: 'Heap usado', value: '98MB', status: 'ok' }, { label: 'Uptime', value: '14h', status: 'ok' }, { label: 'Plan', value: 'Pro', status: 'ok' }], history: [100,100,100,100,100,100,100,100,100,100,100,100] },
  { id: 'vercel',       label: 'Vercel',        category: 'Frontend prod.',   icon: '▲',  status: 'ok',      value: '200 OK',      detail: '245ms',          metrics: [{ label: 'HTTP', value: '200', status: 'ok' }, { label: 'Latencia', value: '245ms', status: 'ok' }, { label: 'Plan', value: 'Pro Plan', status: 'ok' }], history: [100,100,100,100,100,100,100,100,100,100,100,100] },
  { id: 'r2',           label: 'R2 Storage',    category: 'Imágenes',         icon: '☁️', status: 'ok',      value: '€0 (free)',   detail: 'Bucket OK',      metrics: [{ label: 'Bucket', value: 'vitalcasa-fotos', status: 'ok' }, { label: 'Plan', value: 'Free (10GB)', status: 'ok' }], history: [100,100,100,100,100,100,100,100,100,100,100,100] },
  { id: 'wa_business',  label: 'WA Business',   category: 'NF Meta',          icon: '💼', status: 'ok',      value: 'Activo',      detail: 'Meta API OK',    metrics: [{ label: 'Token', value: 'Válido', status: 'ok' }, { label: 'Último msg', value: 'hace 18min', status: 'ok' }], history: [100,100,100,100,100,100,100,100,100,100,100,100] },
  { id: 'scraper',      label: 'ScraperAPI',    category: 'Scraping',         icon: '🕷️', status: 'ok',      value: '4.2k cred.',  detail: 'Quota: 40%',     metrics: [{ label: 'Usadas', value: '2.8k', status: 'ok' }, { label: 'Disponibles', value: '4.2k', status: 'ok' }], history: [100,100,100,100,100,100,100,100,100,100,100,100] },
  { id: 'sentry',       label: 'Sentry',        category: 'Monitoreo errores',icon: '🛡️', status: 'ok',      value: 'Free',        detail: 'Sin issues',     metrics: [{ label: 'Proyectos', value: '1', status: 'ok' }, { label: 'Conectado', value: 'Sí', status: 'ok' }], history: [100,100,100,100,100,100,100,100,100,100,100,100] },
];

const MOCK_LOGS = [
  { id: 1, ts: new Date(Date.now() - 120000), level: 'info', msg: 'Monitor cycle completado en 12.4s' },
  { id: 2, ts: new Date(Date.now() - 180000), level: 'warn', msg: 'SMTP Josefa: connect ETIMEDOUT' },
  { id: 3, ts: new Date(Date.now() - 300000), level: 'info', msg: 'ElevenLabs: 360.420 / 500.000 chars' },
];

const MOCK_TICKETS = [
  { id: 1, ticket_ref: 'TK-0012', user_name: 'Rita García', message: 'La foto de la captación 321 no se sube', status: 'abierto', svc_tag: 'photos', felipe_response: null, created_at: new Date(Date.now() - 3600000) },
];

// ── HOOK ─────────────────────────────────────────────────────
export function useFelipe(userName = '') {
  const [internals, setInternals]     = useState(MOCK_INTERNALS);
  const [externals, setExternals]     = useState(MOCK_EXTERNALS);
  const [logs, setLogs]               = useState(MOCK_LOGS);
  const [tickets, setTickets]         = useState(MOCK_TICKETS);
  const [fixes, setFixes]             = useState([]);
  const [alerts, setAlerts]           = useState([]);
  const [chat, setChat]               = useState(() => [{
    role: 'assistant',
    content: userName ? `Hola ${userName}, ¿en qué te puedo ayudar?` : '¿En qué te puedo ayudar?',
    actions: [],
    created_at: new Date(),
  }]);
  const [connected, setConnected]     = useState(false);
  const [countdown, setCountdown]     = useState(60);
  const [chatLoading, setChatLoading] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [visores, setVisores] = useState(null);

  // Cargar fixes pendientes
  const loadFixes = useCallback(() => {
    fetch(`${API}/fixes?status=pendiente`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (Array.isArray(data)) setFixes(data); })
      .catch(() => {});
  }, []);

  const loadVisores = useCallback(() => {
    fetch(`${API}/visores`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data?.whatsapp && data?.marketplace) setVisores(data); })
      .catch(() => {});
  }, []);
  const loadAlerts = useCallback(() => {
    fetch(`${API}/alerts?status=activa&limit=10`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (Array.isArray(data)) setAlerts(data); })
      .catch(() => {});
  }, []);

  // Datos reales e SSE
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    fetch(`${API}/status`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data?.internal) setInternals(data.internal);
        if (data?.external) setExternals(data.external);
      })
      .catch(() => {});

    fetch(`${API}/logs`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (Array.isArray(data)) setLogs(data); })
      .catch(() => {});

    fetch(`${API}/tickets`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (Array.isArray(data)) setTickets(data); })
      .catch(() => {});

    fetch(`${API}/chat/history`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (Array.isArray(data) && data.length > 0) setChat(prev => [...prev, ...data]); })
      .catch(() => {});

    loadFixes();
    loadAlerts();
    loadVisores();
    const visoresTimer = setInterval(loadVisores, 60_000);

    const es = new EventSource(`${API}/stream?token=${token}`);
    es.onopen = () => setConnected(true);
    es.onerror = () => setConnected(false);
    es.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        if (msg.type === 'monitor_update') {
          if (msg.data?.internal) setInternals(msg.data.internal);
          if (msg.data?.external) setExternals(msg.data.external);
          setCountdown(60);
        }
        if (msg.type === 'log') {
          setLogs(prev => [msg.data, ...prev].slice(0, 200));
        }
        if (msg.type === 'action_required' || msg.type === 'chat_message') {
          setChat(prev => [...prev, {
            role: 'assistant',
            content: msg.data.content || msg.data.message,
            actions: msg.data.actions || [],
            created_at: new Date(),
          }]);
        }
        if (msg.type === 'fix_proposed') {
          setFixes(prev => [msg.data, ...prev]);
        }
        if (msg.type === 'fix_resolved') {
          setFixes(prev => prev.filter(f => String(f.fix_id || f.id) !== String(msg.data.fix_id)));
          loadAlerts();
        }
      } catch {}
    };
    return () => { es.close(); clearInterval(visoresTimer); };
  }, [loadFixes, loadAlerts, loadVisores]);

  useEffect(() => {
    const t = setInterval(() => setCountdown(c => c <= 1 ? 60 : c - 1), 1000);
    return () => clearInterval(t);
  }, []);

  // Enviar mensaje de chat
  const sendMessage = useCallback(async (message) => {
    setChat(prev => [...prev, { role: 'user', content: message, actions: [], created_at: new Date() }]);
    setChatLoading(true);
    try {
      const res = await fetch(`${API}/chat/message`, {
        method: 'POST',
        headers: { ...authHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ message }),
      });
      if (res.ok) {
        const data = await res.json(); // { reply, actions }
        setChat(prev => [...prev, {
          role: 'assistant',
          content: data.reply || data,
          actions: data.actions || [],
          created_at: new Date(),
        }]);
      } else {
        setChat(prev => [...prev, { role: 'assistant', content: 'Error conectando con el backend.', actions: [], created_at: new Date() }]);
      }
    } catch {
      setChat(prev => [...prev, { role: 'assistant', content: 'No se pudo conectar con el backend.', actions: [], created_at: new Date() }]);
    } finally {
      setChatLoading(false);
    }
  }, []);

  // Ejecutar una acción (sin parámetros, o con parámetros ya resueltos)
  const executeAction = useCallback(async (actionId, params = {}) => {
    setActionLoading(true);
    // Mensaje de "ejecutando..." en el chat
    const loadingMsg = { role: 'assistant', content: `⏳ Ejecutando acción...`, actions: [], created_at: new Date() };
    setChat(prev => [...prev, loadingMsg]);
    try {
      const res = await fetch(`${API}/actions/execute`, {
        method: 'POST',
        headers: { ...authHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ action_id: actionId, params }),
      });
      const data = await res.json();
      setChat(prev => {
        const copy = [...prev];
        copy[copy.length - 1] = {
          role: 'assistant',
          content: data.message || (data.ok ? '✅ Hecho.' : '❌ Error.'),
          actions: [],
          created_at: new Date(),
        };
        return copy;
      });
      setPendingAction(null);
    } catch (e) {
      setChat(prev => {
        const copy = [...prev];
        copy[copy.length - 1] = { role: 'assistant', content: `❌ Error ejecutando acción: ${e.message}`, actions: [], created_at: new Date() };
        return copy;
      });
    } finally {
      setActionLoading(false);
    }
  }, []);

  // Iniciar acción que requiere parámetros
  const startActionWithParams = useCallback((action) => {
    setPendingAction(action);
  }, []);

  // Aprobar un fix propuesto por Felipe
  const approveFix = useCallback(async (fixId) => {
    setActionLoading(true);
    try {
      const res = await fetch(`${API}/fixes/${fixId}/approve`, {
        method: 'POST',
        headers: authHeaders(),
      });
      const data = await res.json();
      setChat(prev => [...prev, {
        role: 'assistant',
        content: data.ok ? `✅ Fix ejecutado: ${data.message}` : `❌ Error al ejecutar fix: ${data.message}`,
        actions: [],
        created_at: new Date(),
      }]);
      setFixes(prev => prev.filter(f => f.id !== fixId && f.fix_id !== fixId));
    } catch (e) {
      setChat(prev => [...prev, { role: 'assistant', content: `❌ Error: ${e.message}`, actions: [], created_at: new Date() }]);
    } finally {
      setActionLoading(false);
    }
  }, []);

  const rejectFix = useCallback(async (fixId, reason = '') => {
    try {
      await fetch(`${API}/fixes/${fixId}/reject`, {
        method: 'POST',
        headers: { ...authHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ reason }),
      });
      setFixes(prev => prev.filter(f => f.id !== fixId && f.fix_id !== fixId));
    } catch {}
  }, []);

  const alertCount = [...internals, ...externals].filter(m => m.status === 'error').length;
  const warnCount  = [...internals, ...externals].filter(m => m.status === 'warn').length;

  return {
    internals, externals, visores, logs, tickets, fixes, alerts, chat,
    connected, countdown, chatLoading,
    alertCount, warnCount,
    sendMessage,
    executeAction, startActionWithParams, pendingAction, setPendingAction, actionLoading,
    approveFix, rejectFix, loadFixes,
  };
}
